module.exports = function() {
  return new Worker(__webpack_public_path__ + "39537336e8541993d4eb.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./node_modules/pdfjs-dist/build/pdf.worker.js
// module id = ahHh
// module chunks = 1